
 import * as React from 'react';
 import {createComponent} from '@lit/react';
 
 import {ObiChartScaleMinProposal as ObiChartScaleMinProposalElement} from '@oicl/openbridge-webcomponents/dist/icons/icon-chart-scale-min-proposal.js';
 
 
 

 
 export const ObiChartScaleMinProposal = createComponent({
   react: React,
   tagName: 'obi-chart-scale-min-proposal',
   elementClass: ObiChartScaleMinProposalElement,
   events: {
     
   }
  });
 
 